import {storage} from "../../utilities"

export function baseStore (path) {
  return function (file) {
    const r = storage.ref().child(path + file.name)
    return r.put(file)
  }
}